<template>
  <v-dialog v-model="visible" max-width="600px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="form.nombre"
                label="Nombre"
                required
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="form.unidadNegocio.nombre"
                label="Unidad de Negocio"
                required
                outlined
                dense
                hide-details
                readonly></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.sedeTalentoHumanoId"
                :items="sedesTalentoHumano"
                item-text="nombre"
                item-value="id"
                label="Seleccione la Sede Talento Humano"
                required
                outlined
                dense
                hide-details
                clearable></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" :disabled="guardando" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" :disabled="guardando" :loading="guardando" text @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../../mixins/modal-form.mixin';
import apiConsumerMixin from '../../mixins/api-consumer.mixin';
import talentoHumanoService from '../../services/talento-humano.service';
import sedesService from '../../services/sedes.service';
import { ACCIONES } from '../../utils/constantes';

export default {
  name: 'ModalFormularioSedes',
  mixins: [modalFormMixin, apiConsumerMixin],
  data() {
    return {
      sedesTalentoHumano: [],
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        nombre: null,
        sedeTalentoHumanoId: null,
        unidadNegocioId: null,
        unidadNegocio: {
          id: null,
          nombre: null,
        },
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        nombre: data.nombre,
        sedeTalentoHumanoId: data.sedeTalentoHumanoId,
        unidadNegocioId: data.unidadNegocioId,
        unidadNegocio: data.unidadNegocio,
      };
    },
    abrir(accion, data = []) {
      Promise.all([this.obtenerSedesTalentoHumano()]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    cerrar() {
      this.cerrarMixin();
    },
    async obtenerSedesTalentoHumano() {
      await this.findAllMixin(
        talentoHumanoService.findAllSedes,
        null,
        'SEDES_TALENTO_HUMANO',
        () => {
          this.sedesTalentoHumano = [];
        },
        () => {},
        (datos) => {
          this.sedesTalentoHumano = datos;
        },
        () => {
          this.sedesTalentoHumano = [];
        },
      );
    },
    async guardar() {
      if (this.guardando) {
        return;
      }

      const accion = this.form?.id ? ACCIONES.EDITAR : ACCIONES.REGISTRAR;
      const fnServicio = this.form?.id ? sedesService.update : () => {};

      await this.saveMixin(
        accion,
        fnServicio,
        this.form,
        null,
        'SEDE',
        () => {
          this.guardando = true;
          this.errores = [];
        },
        () => {
          this.guardando = false;
        },
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          if (typeof errores === 'object') {
            this.errores = errores;
          }
        },
      );
    },
  },
};
</script>
